import { Component, Input, OnInit } from '@angular/core';
import { Multimedia } from '@shared/models/multimedia';
import { TRANSLATION_SCOPE } from '../../i18n/scope';

@Component({
  selector: 'app-course-pictures',
  templateUrl: './course-pictures.component.html',
  styleUrls: ['./course-pictures.component.scss'],
})
export class CoursePicturesComponent implements OnInit {
  @Input() medias: Multimedia[];
  @Input() mediaTitle: string;
  translationScope = TRANSLATION_SCOPE;
  slideConfig = {
    slidesToShow: 1.5,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 3000,
    arrows: true,
    infinite: false,
  };

  constructor() {}

  ngOnInit() {}

  openImagePreviewer(mediaUrl: any): void {}

  getExperienceNonDefaultMedia(mediaList: Multimedia[]): Multimedia[] {
    return mediaList.filter((x) => x.default === false);
  }
}
